'use client';

import type { PropsWithChildren, ReactNode } from 'react';
import { cn } from '@/utils/shad';

type NebulyPageStatusPanelProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
  actions?: ReactNode;
  className?: string;
  'data-testid'?: string;
};

export function NebulyPageStatusPanel({
  title,
  description,
  icon,
  actions,
  className,
  children,
  'data-testid': dataTestId,
}: PropsWithChildren<NebulyPageStatusPanelProps>) {
  return (
    <div
      className={cn(
        'flex min-h-[min(60vh,32rem)] flex-1 flex-col items-center justify-center px-8 py-16 text-center',
        className,
      )}
      data-testid={dataTestId}
    >
      {icon ? <div className="mb-6">{icon}</div> : null}
      <h2 className="mb-3 text-lg font-semibold">{title}</h2>
      {description ? <p className="mb-6 max-w-lg text-sm text-darkgrey">{description}</p> : null}
      {children}
      {actions ? <div className="flex flex-wrap items-center justify-center gap-2">{actions}</div> : null}
    </div>
  );
}
